const roleEvent = {
  ADD_ORGANIZATION_DRIVE: 'ADD_ORGANIZATION_DRIVE',
  EDIT_ORGANIZATION_DRIVE: 'EDIT_ORGANIZATION_DRIVE',
  DEL_ORGANIZATION_DRIVE: 'DEL_ORGANIZATION_DRIVE'
};

export default roleEvent;